// export const BASE_URL =
//   process.env.NODE_ENV === 'development' ? 'http://localhost:5003' : '';
//if using proxy (package.json)
export const BASE_URL = '/';
export const ARTWORKS_URL = '/api/artworks';
export const USERS_URL = '/api/users';
export const ORDERS_URL = '/api/orders';
export const PAYPAL_URL = '/api/config/paypal';
export const UPLOADS_URL = '/api/upload';
export const CONTACT_URL = '/api/contact';
